import axios from 'axios';
import { API_BASE_URL } from './config';

export const partnerDocumentService = {
  getAllDocuments: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/partner-documents`, {
        withCredentials: true
      });
      return response.data;
    } catch (error) {
      console.error('Fehler beim Abrufen der Dokumente:', error);
      throw error;
    }
  },

  getDocumentsByCategory: async (category) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/partner-documents/category/${category}`, {
        withCredentials: true
      });
      return response.data;
    } catch (error) {
      console.error('Fehler beim Abrufen der Dokumente nach Kategorie:', error);
      throw error;
    }
  }
};